import { Directive, ElementRef, EventEmitter, HostListener, inject, Input, Output } from '@angular/core';
import { ConfirmActionModalButton, ConfirmActionModalOptions } from '../../models/confirm-action-modal-options.model';
import { ConfirmActionModalService } from '../../services/confirm-action-modal/confirm-action-modal.service';

@Directive({
  selector: '[workUiShowConfirmActionModal]',
  standalone: true,
})
export class ConfirmActionModalDirective {
  @Input() modalOptions?: ConfirmActionModalOptions;
  @Output() actionConfirmResult: EventEmitter<ConfirmActionModalButton | undefined> = new EventEmitter();
  private readonly confirmActionModalService = inject(ConfirmActionModalService);
  private readonly elementRef = inject(ElementRef);

  @HostListener('click')
  @HostListener('buttonClick')
  open() {
    if (this.isElementDisabled()) {
      return;
    }
    this.confirmActionModalService.showModal(this.modalOptions).subscribe({
      next: (button: ConfirmActionModalButton | undefined) => {
        if (!button || (button && button.role && button.role === 'cancel')) {
          return;
        }
        this.actionConfirmResult.emit(button);
      },
    });
  }

  private isElementDisabled(): boolean {
    let isDisabled = false;
    try {
      isDisabled = this.elementRef.nativeElement.attributes.getNamedItem('ng-reflect-disabled').nodeValue === 'true';
    } catch (noNgReflectAttribute) {
      // Nothing to do here.
    }
    try {
      isDisabled = this.elementRef.nativeElement.attributes.getNamedItem('disabled').nodeValue === 'true';
    } catch (noDisabledAttribute) {
      // Nothing to do here.
    }
    try {
      const button = this.elementRef.nativeElement.querySelector('button');
      if (button) {
        isDisabled = button.disabled;
      }
    } catch (noNgReflectAttribute) {
      // Nothing to do here.
    }
    return isDisabled;
  }
}
